export const PAYMENT_BRAND_LOGOS = {
  cashapp: '/payment-logos/cash-app.svg',
  cash_app: '/payment-logos/cash-app.svg',
  applepay: '/payment-logos/apple-pay.svg',
  apple_pay: '/payment-logos/apple-pay.svg',
  googlepay: '/payment-logos/google-pay.svg',
  google_pay: '/payment-logos/google-pay.svg',
  chime: '/payment-logos/chime.svg',
  btc: '/payment-logos/bitcoin.svg',
  bitcoin: '/payment-logos/bitcoin.svg',
  crypto: '/payment-logos/usdt.svg',
  usdt: '/payment-logos/usdt.svg',
  tether: '/payment-logos/usdt.svg',
  nowpayments: '/payment-logos/usdt.svg',
};

export const PAYMENT_ICONS = [
  { name: 'Cash App', logoSrc: PAYMENT_BRAND_LOGOS.cashapp, tone: '#00D632', logoShape: 'mark' },
  { name: 'Apple Pay', logoSrc: PAYMENT_BRAND_LOGOS.applepay, tone: '#111111', logoShape: 'wordmark' },
  { name: 'Google Pay', logoSrc: PAYMENT_BRAND_LOGOS.googlepay, tone: '#4285F4', logoShape: 'wordmark' },
  { name: 'Chime', logoSrc: PAYMENT_BRAND_LOGOS.chime, tone: '#00B26B', logoShape: 'wordmark' },
  { name: 'Crypto', logoSrc: PAYMENT_BRAND_LOGOS.usdt, tone: '#26A17B', logoShape: 'mark' },
];

const normaliseBrandKey = (value = '') =>
  String(value).toLowerCase().trim().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');

export function resolvePaymentBrandLogo(method = {}) {
  const candidates = [
    method.gateway_method_code,
    method.gateway_method,
    method.method,
    method.code,
    method.provider_code,
    method.gateway_provider,
    method.title,
    method.name,
  ];

  for (const candidate of candidates) {
    const key = normaliseBrandKey(candidate);
    if (PAYMENT_BRAND_LOGOS[key]) return PAYMENT_BRAND_LOGOS[key];
    const compact = key.replace(/_/g, '');
    if (PAYMENT_BRAND_LOGOS[compact]) return PAYMENT_BRAND_LOGOS[compact];
    if (key.includes('cash')) return PAYMENT_BRAND_LOGOS.cashapp;
    if (key.includes('apple')) return PAYMENT_BRAND_LOGOS.applepay;
    if (key.includes('google')) return PAYMENT_BRAND_LOGOS.googlepay;
    if (key.includes('chime')) return PAYMENT_BRAND_LOGOS.chime;
    if (key.includes('bitcoin') || key === 'btc') return PAYMENT_BRAND_LOGOS.bitcoin;
    if (key.includes('usdt') || key.includes('tether') || key.includes('crypto')) return PAYMENT_BRAND_LOGOS.usdt;
  }

  return null;
}

export function resolvePaymentLogoShape(logoSrc = '', method = {}) {
  const src = String(logoSrc || '');
  const title = normaliseBrandKey(method.title || method.name || method.code || method.provider_code || '');
  if (
    src.includes('chime') ||
    src.includes('apple-pay') ||
    src.includes('google-pay') ||
    title.includes('chime') ||
    title.includes('apple') ||
    title.includes('google')
  ) {
    return 'wordmark';
  }
  return 'mark';
}
